
import makerjs from "makerjs";
function C02(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  // console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    D = Param[0].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       d = D * 1 * myZoom,       
       h = d,
       w = d,
       r=d/2,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x=r,y=r,glassH = h, glassW = w;

   if (d !== 0) {
       var TxtD = "D="+D;
   } 



   var drawAbnormalShapeC02 = {
       paths: {
          "holesAUp": new makerjs.paths.Arc([r, r], r, 180,0),
          "holesADn": new makerjs.paths.Arc([r, r], r, 0,180),
    
       }
   };
   var drawAbnormalShapeC02MarkD = {
       paths: {
        "LeftLine": new makerjs.paths.Line([0, r], [d, r]),
       }
   };
   makerjs.model.addCaption(drawAbnormalShapeC02MarkD, TxtD, [0, r+markShift], [d, r+markShift]);//长度文字  
   
  plate={
    models: {
      drawAbnormalShapeC02: drawAbnormalShapeC02,
      }
    };
    markers={
      models: {
        drawAbnormalShapeC02: drawAbnormalShapeC02,
        drawAbnormalShapeC02MarkD: drawAbnormalShapeC02MarkD,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default C02;